/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import DiscountCodeForm from '../codeForm/discountCodeForm';
import PurchaseTable from '../purchase/purchaseTable';

type StepPurchaseType = {
  eventDetail: {
    discounts: []
  },
  visibleTickets: [],
  buyCart: [],
  onHandleUpdateBuyCart: () => void,
  onHandleUpdateVT: () => void,
  onHandleSetTotal: () => void
};

export const StepPurchase = (props: StepPurchaseType): React.Element<'div'> => {
  const {
    eventDetail,
    visibleTickets,
    buyCart,
    onHandleUpdateBuyCart,
    onHandleUpdateVT,
    onHandleSetTotal
  } = props;

  const groupCartItemsById = (items: any[]): any[] => {
    const res = {};

    items.forEach((cartItem: any) => {
      const key = cartItem.id;

      if (!res[key]) {
        res[key] = { ...cartItem, countSelectedCartItems: 0 };
      }
      res[key].countSelectedCartItems += 1;
    });
    const arr = [];

    Object.keys(res).map((e: any) => {
      arr.push(res[e]);
    });
    return arr;
  };
  const groupedCartItems = groupCartItemsById(buyCart);

  return (
    <>
      {!!_.size(eventDetail.discounts) &&
        <DiscountCodeForm
          eventDetail={eventDetail}
          buyCart={buyCart}
          visibleTickets={visibleTickets}
          handleUpdateBuyCart={onHandleUpdateBuyCart}
          handleUpdateVT={onHandleUpdateVT}
        />
      }
      <PurchaseTable
        cartItems={groupedCartItems}
        eventDetail={eventDetail}
        handleSetTotal={onHandleSetTotal}
      />
    </>
  );
};
